export var Sides = {
  Left: 'LEFT',
  Right: 'RIGHT'
};